import { AxiosError } from "axios";
import { useNotificationStore } from "@/store/notificationStore";

export type ErrorType = AxiosError | string;

export interface ApiError {
  error: string;
}

export function getErrorText(error: ErrorType): string {
  if (typeof error === "string") {
    return error;
  }

  if ("isAxiosError" in error && error.isAxiosError && error.response) {
    const data = error.response.data as ApiError | undefined;
    if (data && typeof data.error === "string") {
      return data.error;
    }
    return error.message;
  }

  return "Unknown error";
}

export type NotificationType = "success" | "error";

export interface AlertOptions {
  error?: ErrorType;
  text?: string;
  type?: NotificationType;
}

export function showNotification({ error, text, type }: AlertOptions): void {
  const content = error ? getErrorText(error) : text || "";
  const notifType: NotificationType = error ? "error" : type || "success";
  useNotificationStore.getState().addNotification(content, notifType);
}
